(() => {
  const configElement = document.getElementById('nobs-commerce-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const root = window.Shopify?.routes?.root || '/';
  let checkoutBusy = false;
  let middlewareBypass = false;
  const cart = async () => {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(config.error);
    return response.json();
  };
  const formFor = option => {
    const scope = option.closest('[data-nobs-native-options]');
    return scope ? document.getElementById(scope.dataset.nobsFormId) : option.closest('form');
  };
  const sync = option => {
    if (!option?.checked) return;
    const form = formFor(option);
    if (!form) return;
    const quantity = form.querySelector('[name="quantity"]');
    const plan = form.querySelector('[name="selling_plan"]');
    if (quantity) quantity.value = option.dataset.nobsQuantity || '1';
    if (plan) { plan.value = option.dataset.nobsSellingPlan || ''; plan.disabled = !plan.value; }
    form.dataset.nobsPurchaseType = option.value;
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-nobs-purchase-option]')) sync(event.target);
  });
  document.addEventListener('click', event => {
    if (!event.target.closest?.('a[href="#nobs-purchase-options"], [data-nobs-sticky-add]')) return;
    const option = document.querySelector('[data-nobs-native-options] [data-nobs-purchase-option][value="subscription"]');
    if (option) { option.checked = true; option.dispatchEvent(new Event('change', { bubbles: true })); }
  }, true);
  const init = () => document.querySelectorAll('[data-nobs-purchase-option]:checked').forEach(sync);
  init();
  document.addEventListener('shopify:section:load', init);
  const enhanceCart = () => {
    document.querySelectorAll('.mw-btn-modal').forEach(button => { button.setAttribute('role', 'button'); button.tabIndex = 0; });
    document.querySelectorAll('.cart-item').forEach(row => {
      if (!row.querySelector(`a[href*="selling_plan=${config.plan}"]`)) return;
      const quantity = row.querySelector('quantity-input');
      const input = quantity?.querySelector('input');
      if (!input) return;
      input.readOnly = true;
      quantity.querySelectorAll('button').forEach(button => { button.disabled = true; });
    });
  };
  enhanceCart();
  let enhancePending = false;
  new MutationObserver(() => { if (enhancePending) return; enhancePending = true; requestAnimationFrame(() => { enhancePending = false; enhanceCart(); }); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('keydown', event => { if (event.target.matches('.mw-btn-modal') && ['Enter', ' '].includes(event.key)) { event.preventDefault(); event.target.click(); } });
  const showError = (form, error) => {
    let message = form.querySelector('.nobs-commerce-error');
    if (!message) { message = document.createElement('p'); message.className = 'nobs-commerce-error'; message.setAttribute('role', 'alert'); form.append(message); }
    message.textContent = error.message || config.error;
    message.hidden = false;
  };
  const openMiddleware = async () => {
    const drawer = document.querySelector('cart-drawer');
    drawer?.open();
    const deadline = Date.now() + 6000;
    while (Date.now() < deadline) {
      const button = document.querySelector('.mw-btn-modal');
      if (button) { middlewareBypass = true; button.click(); middlewareBypass = false; return; }
      await new Promise(resolve => setTimeout(resolve, 150));
    }
    window.location.assign(root + 'cart');
  };
  const routeCheckout = async (currentCart = null) => {
    const current = currentCart || await cart();
    if (!current.items?.length) return;
    const hasSubscription = current.items.some(item => item.selling_plan_allocation);
    const hasPhysical = current.items.some(item => item.requires_shipping);
    if (hasSubscription || !hasPhysical) window.location.assign(root + 'checkout');
    else await openMiddleware();
  };
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;
    const variant = String(new FormData(form).get('id') || '');
    if (variant !== String(config.variant) && !form.matches('[data-nobs-product-form]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.nobsSubmitting === 'true') return;
    form.dataset.nobsSubmitting = 'true';
    const button = event.submitter || form.querySelector('[type="submit"]');
    const priorDisabled = button?.disabled;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    form.querySelector('.nobs-commerce-error')?.setAttribute('hidden', '');
    try {
      const scope = document.querySelector(`[data-nobs-form-id="${form.id}"]`) || form;
      const selected = scope.querySelector('[data-nobs-purchase-option]:checked');
      if (selected) sync(selected);
      const data = new FormData(form);
      const sellingPlan = String(data.get('selling_plan') || '');
      if (selected?.value === 'subscription' && !sellingPlan) throw new Error(config.missingPlan);
      const quantity = sellingPlan && variant === String(config.variant) ? 3 : Math.max(1, Number(data.get('quantity') || 1));
      const item = { id: variant, quantity };
      if (sellingPlan) item.selling_plan = sellingPlan;
      const properties = {};
      for (const [key, value] of data.entries()) { const match = key.match(/^properties\[(.+)\]$/); if (match && typeof value === 'string') properties[match[1]] = value; }
      if (Object.keys(properties).length) item.properties = properties;
      const items = [item];
      if (sellingPlan && variant === String(config.variant)) {
        const current = await cart();
        for (const gift of config.gifts) if (!current.items.some(line => String(line.variant_id) === String(gift))) items.push({ id: String(gift), quantity: 1, properties: { _nobs_subscription_bonus: 'magcore' } });
      }
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.().map(section => section.id) || [];
      const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections, sections_url: window.location.pathname }) });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || config.error);
      if (drawer && result.sections) {
        drawer.classList.remove('is-empty');
        drawer.setActiveElement(button || document.activeElement);
        drawer.renderContents(result);
      }
      window.dispatchEvent(new CustomEvent('nobs:add_to_cart', { detail: { variant, quantity, sellingPlan: sellingPlan || null } }));
      if (!sellingPlan && variant === String(config.variant)) await routeCheckout();
      else if (!drawer) window.location.assign(root + 'cart');
    } catch (error) { showError(form, error); }
    finally { delete form.dataset.nobsSubmitting; if (button) { button.disabled = priorDisabled; button.removeAttribute('aria-busy'); } }
  }, true);
  document.addEventListener('click', async event => {
    const target = event.target.closest?.('[name="checkout"],a[href$="/checkout"],.mw-btn-modal');
    if (!target || middlewareBypass) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    try { await routeCheckout(); }
    catch (error) { const form = target.closest('form') || document.querySelector('form[action*="/cart"]'); if (form) showError(form, error); }
    finally { checkoutBusy = false; }
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action$="/cart"]') || event.submitter?.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    try { await routeCheckout(); } catch (error) { showError(form, error); } finally { checkoutBusy = false; }
  }, true);
})();
